import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { TurnosProduccionApi } from "../../../api/TurnosProduccionApi";
import Paginacion from "../../../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../../../Utils/LoadMask/LoadMask";
import { FiltrosOrdenesProd } from "./FiltrosOrdenesProd";
import { OrdenesProdTable } from "./OrdenesProdTable";
import { useDebounce } from "../../../../../../../../Utils/Hooks/useDebounce";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../../../utility/utils";
import { FormInicioProd } from "./FormInicioProd";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../../utility/constants";
import { ProduccionV2Api } from "../../../../../../api/ProduccionV2Api";

export const ListadoOrdenes = ({ turnoActual, navigateToTancadas, estado }) => {
    const { control, watch } = useForm();

    const [ordenesProduccion, setOrdenesProduccion] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const { getOrdenesProduccion, iniciarOrdenProduccion, cargando } =
        TurnosProduccionApi();

    const { completarOrdenProduccion, cargando: cargandoCompletar } =
        ProduccionV2Api();

    const GetOrdenesProduccion = async () => {
        if (!turnoActual) return;

        try {
            const params = {
                page: paginaSeleccionada,
                estado: estado,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getOrdenesProduccion(params);
            setOrdenesProduccion(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las ordenesProduccion",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setOrdenesProduccion([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetOrdenesProduccion();
    }, [
        debouncedSearch,
        fecha_inicial,
        fecha_final,
        paginaSeleccionada,
        turnoActual,
    ]);

    const paletizacionCerrada = turnoActual
        ? turnoActual.paletizacion_cerrada
        : false;

    const IniciarOrdenProduccion = async (idOrden) => {
        try {
            if (!paletizacionCerrada) {
                await iniciarOrdenProduccion(idOrden);

                NotificationManager.success(
                    "Orden de producción iniciada correctamente",
                    "Éxito",
                    3000,
                );
            }

            navigateToTancadas(idOrden, paletizacionCerrada);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al iniciar orden de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const VerificarEstadoOrden = async (ordenSeleccionada) => {
        // si la orden ya está en proceso, solo se navega a sus tancadas,
        // ya no es necesario volver a llamar iniciar_orden
        if (ordenSeleccionada.estado === ESTADOS_ORDEN_PRODUCCION.EN_PROCESO) {
            navigateToTancadas(ordenSeleccionada.id, paletizacionCerrada);
            return;
        }

        await IniciarOrdenProduccion(ordenSeleccionada.id);
    };

    const CompletarOrdenProduccion = async (idOrden) => {
        try {
            await completarOrdenProduccion(idOrden);

            NotificationManager.success(
                "Orden de producción detenida correctamente",
                "Éxito",
                3000,
            );
            GetOrdenesProduccion();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al detener orden de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return (
        <div className="turnos-produccion__tab-wrapper">
            <LoadMask loading={cargando || cargandoCompletar} blur>
                <CardEmpty noShadow>
                    <React.Fragment>
                        <div className="turnos-produccion__table-header">
                            <FiltrosOrdenesProd
                                control={control}
                                onRefresh={() => {
                                    GetOrdenesProduccion();
                                }}
                                resetPage={() => setPaginaSeleccionada(1)}
                                searchPlaceholder={"EVS, cliente, producto"}
                            />
                        </div>

                        <OrdenesProdTable
                            ordenesProduccion={ordenesProduccion}
                            IniciarOrdenProduccion={VerificarEstadoOrden}
                            CompletarOrdenProduccion={CompletarOrdenProduccion}
                            estado={estado}
                        />
                        <Paginacion
                            cantidadResultados={cantidadResultados}
                            paginaSeleccionada={paginaSeleccionada}
                            setPaginaSeleccionada={setPaginaSeleccionada}
                        />
                    </React.Fragment>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
